import React from 'react';
import { Mail, MapPin, Phone, Sparkles } from 'lucide-react';
import '../styles/contact.css';
import bgimg from "../global-images/footerimgbg.webp";



function Contact() {
  return (
    <div className="relative min-h-screen bg-gray-50 py-24 px-4 sm:px-6 lg:px-8 overflow-hidden flex items-center justify-center font-sans">
      
      {/* Modern Background Decorative Blobs */}
      <div className="absolute top-0 left-0 w-[500px] h-[500px] bg-blue-300/30 rounded-full mix-blend-multiply filter blur-3xl opacity-70 animate-blob z-0"></div>
      <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-indigo-300/30 rounded-full mix-blend-multiply filter blur-3xl opacity-70 animate-blob animation-delay-2000 z-0"></div>
      <div className="absolute -bottom-32 left-20 w-[500px] h-[500px] bg-purple-300/30 rounded-full mix-blend-multiply filter blur-3xl opacity-70 animate-blob animation-delay-4000 z-0"></div>

      {/* Main Glassmorphism Card */}
      <div className="relative z-10 max-w-7xl w-full bg-white/90 backdrop-blur-xl rounded-[2.5rem] shadow-[0_8px_30px_rgb(0,0,0,0.08)] border border-white overflow-hidden flex flex-col lg:flex-row">
        
        {/* Left Side: Contact Info & Image */}
        <div className="w-full lg:w-5/12 p-8 md:p-12 lg:p-14 flex flex-col justify-between bg-white border-r border-gray-100">
          <div>
            {/* Badge */}
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-blue-50 border border-blue-100 rounded-full w-max shadow-sm mb-6">
              <Sparkles className="w-4 h-4 text-blue-600" />
              <span className="text-sm font-bold tracking-widest text-blue-700 uppercase">
                Get In Touch
              </span>
            </div>
            
            <h2 className="text-4xl lg:text-5xl font-extrabold text-gray-900 tracking-tight mb-4">
              Let's <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-indigo-600">Connect</span>
            </h2>
            
            <p className="text-lg text-gray-600 leading-relaxed mb-10">
              We're here to assist you! If you have any questions, need assistance, or want to collaborate with IIT Ropar TBIF, please feel free to reach out.
            </p>

            {/* Contact Details */}
            <div className="space-y-6 mb-10">
              <div className="flex items-start gap-4 group">
                <div className="p-3 bg-blue-50 text-blue-600 rounded-xl group-hover:bg-blue-600 group-hover:text-white transition-colors duration-300">
                  <Mail className="w-6 h-6" />
                </div>
                <div>
                  <h4 className="text-gray-900 font-semibold text-lg">Email Us</h4>
                  <a href="mailto:tbif@iitrpr.ac.in" className="text-gray-600 hover:text-blue-600 transition-colors">
                    tbioffice@iitrpr.ac.in
                  </a>
                </div>
              </div>
              
              <div className="flex items-start gap-4 group">
                <div className="p-3 bg-blue-50 text-blue-600 rounded-xl group-hover:bg-blue-600 group-hover:text-white transition-colors duration-300">
                  <Phone className="w-6 h-6" />
                </div>
                <div>
                  <h4 className="text-gray-900 font-semibold text-lg">Call Us</h4>
                  <p className="text-gray-600">TBIF Office: +91-9417484881</p>
                </div>
              </div>

              <div className="flex items-start gap-4 group">
                <div className="p-3 bg-blue-50 text-blue-600 rounded-xl group-hover:bg-blue-600 group-hover:text-white transition-colors duration-300">
                  <MapPin className="w-6 h-6" />
                </div>
                <div>
                  <h4 className="text-gray-900 font-semibold text-lg">Location</h4>
                  <p className="text-gray-600">
                    Top Floor (East Wing), M. Visvesvaraya Block,
                    Indian Institute Of Technology, Ropar,
                    Rupnagar - 140001, Punjab, India
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Image styling */}
          <div className="mt-8 relative group overflow-hidden rounded-2xl shadow-lg border border-gray-100">
            <div className="absolute inset-0 bg-blue-600/20 group-hover:bg-transparent transition-colors duration-500 z-10"></div>
            <img 
              src={bgimg} 
              alt="IIT Ropar Startup" 
              className="w-full h-48 md:h-56 lg:h-64 object-cover transform group-hover:scale-105 transition-transform duration-700"
            />
          </div>
        </div>

        {/* Right Side: Google Form Iframe */}
        <div className="w-full lg:w-7/12 bg-gray-50 flex flex-col items-center justify-center p-0">
          <iframe 
            src="https://docs.google.com/forms/d/e/1FAIpQLSebrTGymn_GMTmlj55L6qHh7nuu1Dbs3Oq3WqBieeGX_ErWWg/viewform?embedded=true"
            title="IIT Ropar Contact Form"
            frameBorder="0"
            marginHeight="0"
            marginWidth="0"
            className="w-full h-[850px] lg:h-full min-h-[850px] bg-transparent"
          >
            Loading Form
          </iframe>
        </div>

      </div>
    </div>
  );
}

export default Contact;